// The assistant's deep-link payload (listRouteKey + filters) → a product list route.
import { ROUTES } from '@/app/routes';

// Backend LIST_ROUTE_KEY → the ROUTES builder for that list. Each takes the module slug.
const ROUTE_BY_LIST_KEY = {
  INBOUND_CONTRACTS: ROUTES.contracts,
  INBOUND_INCOMING_SHIPMENTS: ROUTES.incomingShipments,
  INBOUND_DECLARATIONS: ROUTES.declarations,
  OUTBOUND_ORDERS: ROUTES.orders,
  OUTBOUND_OUTGOING_SHIPMENTS: ROUTES.outgoingShipments,
  OUTBOUND_ALLOCATIONS: ROUTES.allocations,
  MONITOR_INVENTORY: ROUTES.inventory,
  TRANSACTIONS: ROUTES.transactions,
};

// Resolve a navigation payload to a list path for the given module slug, or null.
export const assistantListPath = (navigation, module) => {
  const routeFn = navigation ? ROUTE_BY_LIST_KEY[navigation.listRouteKey] : null;
  return routeFn ? routeFn(module) : null;
};
